import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=b9e0b9ee&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9e0b9ee')) {
      api.createRecord('b9e0b9ee', component.options)
    } else {
      api.reload('b9e0b9ee', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=b9e0b9ee&", function () {
      api.rerender('b9e0b9ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eNDdL0hWFzYT/JS/comp/FavElement.vue"
export default component.exports